import graphql__dd59f855a737b76daad4 from "./__generated__/UserMarkerTooltipContent_user.graphql.js";import { graphql, useFragment } from "react-relay";
import UserGroups from "../../Users/UserGroups";

const UserMarkerTooltipContent = props => {
  const user = useFragment(UserMarkerTooltipContent_user, props.user);
  const { name } = user;

  return (
    <>
      <b>{name}</b>

      <UserGroups user={user} />
    </>
  );
};

const UserMarkerTooltipContent_user = graphql__dd59f855a737b76daad4;

export default UserMarkerTooltipContent;
